<template>
  <section class="n-view-register h-screen p-10 flex justify-center items-center">
    <NCard class="w-full max-w-[450px] shadow-md">
      <div class="text-center">
          <div class="xl:w-[400px] py-2 grid grid-cols-1 xl:grid-cols-1 gap-3">
            <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openIosAppLink">
              <template #icon><img src="/images/system/ats-ios.png" class="inline-block w-[20px]" /></template>
              <span class="pl-2 system-info">{{ $tl('ios') }}</span>
            </NButton>
            <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openAndroidAppLink">
              <template #icon><img src="/images/system/ats-android.png" class="inline-block w-[20px]" /></template>
              <span class="pl-2 system-info">{{ $tl('android') }}</span>
            </NButton>
            <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openWindowsDesktopAppLink">
              <template #icon><img src="/images/system/desktop.png" class="inline-block w-[20px]" /></template>
              <span class="pl-2 system-info">{{ $tl('windowsDesktop') }}</span>
            </NButton>
            <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openMacX86DesktopAppLink">
              <template #icon><img src="/images/system/mac.png" class="inline-block w-[20px]" /></template>
              <span class="pl-2 system-info">{{ $tl('macX86Desktop') }}</span>
            </NButton>
            <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openMacArmDesktopAppLink">
              <template #icon><img src="/images/system/mac.png" class="inline-block w-[20px]" /></template>
              <span class="pl-2 system-info">{{ $tl('macArmDesktop') }}</span>
            </NButton>
            <NButton type="dashed" size="large" class="!text-left !pl-4" @click="openWebLink">
              <template #icon><img src="/images/system/ats-web.png" class="inline-block w-[20px]" /></template>
              <span class="pl-2 system-info">{{ $tl('web') }}</span>
            </NButton>
          </div>
      </div>
      <div class="mt-10 mb-3 text-center text-base text-gray-600 grid items-center gap-3 grid-flow-col place-content-center">
        {{ COPYRIGHT }}
        <NChannelSwitch />
        <NLanguageSwitcher />
        <NHelper />
      </div>
    </NCard>
  </section>
</template>

<script setup>
import {COPYRIGHT} from '@front/constant';
import {useAppDownloads, useLanguage, useRouter} from '@front/hooks';

const { tl, t, PREFIX } = useLanguage();
const { router, routerTo } = useRouter();
const { openIosAppLink, openAndroidAppLink, openWindowsDesktopAppLink, openMacX86DesktopAppLink, openMacArmDesktopAppLink, openWebLink } = useAppDownloads();
</script>

<style lang="less">
.n-view-register {
  background-image: url('/images/shape01.png');
  background-position: center;

  .n-language-switcher {
    gap: 6px;
  }
}
</style>
